// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"exam_preparation_list_wrapper__leQN5","card":"exam_preparation_list_card__2S4WE","detail":"exam_preparation_list_detail__D4INo"};